export const Theme = {
  font: {
    family:
      "Inter, -apple-system, sans-serif, Poppins",
    light: 300,
    normal: 400,
    bold: 600,
    sizes: {
      zsmall: "12px",
      xxxsmall: "16px",
      xxsmall: "18px",
      xsmall: "22px",
      small: "26px",
      medium: "36px",
      large: "44px",
    },
  },
  box: {
    shadow: "0 2px 2px 2px rgba(0, 0, 0, 0.1)",
  },
  border: {
    radius: "15px",
  },
  colors: {
    cor_azul: "#3563e9",
    cor_azul_200: "#87b5fb",
    cor_azul_marinho: "#54bab1",

    cor_texto: "#030303",
    cor_texto_300: "#1a202c",
    cor_texto_400: "#93a6ca",
    cor_texto_500: "#1d1e21",

    cor_cinza: "#929395",
    cor_cinza_200: "#90a3bf",
    cor_cinza_300: "#93a6ca66",
    cor_cinza_400: "#596780",
    cor_cinza_500: "#acadb3",

    cor_branca: "#fff",
    cor_branca_200: "#e1e1e1",
    cor_branca_300: "#f6f7f9",

    gradient_xp: "#f1f3fc",

    footer: "#1e242d",

    botao: "#3083ff",
    botao_hover: "#87b5fb",

    cor_vermelha: "#ff0000"
  }
}
